import Vue from 'vue'
import Router from 'vue-router'
import TournamentPage from '@/screens/tournament'
import MainPage from '@/screens/main_page'
import HistoryPage from '@/screens/history'
import GamePage from '@/screens/game'
import WalletPage from '@/screens/wallet'
import AccountPage from '@/screens/account'
import VueLocalStorage from 'vue-localstorage'
import VueSocialSharing from 'vue-social-sharing'
import InfiniteLoading from 'vue-infinite-loading';

Vue.use(Router)
Vue.use(InfiniteLoading)
Vue.use(VueSocialSharing)
Vue.use(VueLocalStorage, {
  name: "ls",
  bind: true
});

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/main_page',
      name: 'main_page',
      component: MainPage
    },
    {
      path: '/',
      name: 'tournament',
      component: TournamentPage
    },
    {
      path: '/history',
      name: 'history',
      component: HistoryPage
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: WalletPage
    },
    {
      path: '/account',
      name: 'account',
      component: AccountPage
    },
    {
      path: '/game',
      name: 'game',
      component: GamePage
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js